<template>
    <div class="payment-information">
        <slot name="title">
            <div v-if="showTitle" class="row">
                <div class="col-sm-12" v-if="editMode">
                    <h3 class="text-left text-normal">
                        Receiver’s Bank Information
                    </h3>
                    <div class="row">
                        <div class="col-sm-12 margin-0 hint-text receivers-bank">This information will be verified in order to fully activate your account and enable all features. Please fill in the exact information as it's present on your tax documents.</div>
                    </div>
                </div>
                <div class="col-sm-12" v-if="!editMode">
                    <h3 class="text-left text-normal">
                        Receiver’s Bank Information
                        
                    </h3>
                    <div class="d-flex">
                        <div class="col-md-1 pr-0 mt-5">
                          <font-awesome-icon :class="status.class" :icon="status.icon" class="status-icon"/>
                        </div>
                        <h6 class="text-left text-normal col-md-12" :class="status.class">
                          Status: {{userData.status_label}}
                        </h6>
                         <div class="col-md-6 col-sm-6 text-right ml-auto" v-if="!editMode && showEdit">
                              <div class="row pr-0">
                                  <img src="/dist/site/static/icons/edit.svg" class="edit-icon" alt="Edit">		
                                  <a href="#" @click.prevent="toggleEditMode()" class="edit-info-text">
                                          Edit 
                                  </a>
                              </div>
                          </div>
                      </div>
                       
                      <h6 class="text-left text-normal" :class="status.class" v-if="userData.status_label === 'Critical'">
                          Message: {{errors.get('stripeErrors')}}</h6>
                      </div>
                    
                <div v-if="editMode">
                    <div class="col-sm-12" v-if="errors.has('internalError')">
                        <div class="text-left text-danger">
                            There was an error processing your bank information. Please try again
                            later.
                        </div>
                    </div>
                    <div class="col-sm-12" v-if="errors.has('stripeErrors')">
                        <div class="invalid-feedback-red">
                            {{errors.get('stripeErrors')}}
                        </div>
                    </div>
                </div>
            </div>
        </slot>

        <div v-if="!editMode" class="margin-top-20 margin-bottom-20">
            <div v-if="userData.business_name">
                <div class="row">
                    <div class="form-group col-sm-12">
                      <label class="hh-input-label">Legal Business name</label>
                      <span class="form-control overflow-x" :class="!userData.business_name ? 'form-color' : ''">
                              {{userData.business_name}}
                          </span>
                      <div :class="status.class" v-if="errors.has('business_name')">
                        {{errors.get('business_name')}}
                      </div>
                    </div>
                    <div class="form-group col-sm-12">
                        <label class="hh-input-label">Business Type</label>
                        <span class="form-control overflow-x" :class="!businessTypeLabel ? 'form-color' : ''">
                            {{businessTypeLabel}}
                        </span>
                        <div :class="status.class" v-if="errors.has('business_type')">
                            {{errors.get('business_type')}}
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label class="hh-input-label">Business Representative First Name</label>
                    <span class="form-control overflow-x" :class="!userData.first_name ? 'form-color' : ''">
                                {{userData.first_name}}
                            </span>
                    <div :class="status.class" v-if="errors.has('first_name')">
                      {{errors.get('first_name')}}
                    </div>
                  </div>

                  <div class="form-group col-sm-6">
                    <label class="hh-input-label">Business Representative Last Name</label>
                    <span class="form-control overflow-x" :class="!userData.last_name ? 'form-color' : ''">
                                {{userData.last_name}}
                            </span>
                    <div :class="status.class" v-if="errors.has('last_name')">
                      {{errors.get('last_name')}}
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-12">
                        <label class="hh-input-label">Tax ID</label>
                        <span class="form-control overflow-x"
                              :class="!userData.identification_number ? 'form-color' : ''">
                            {{userData.identification_number}}
                        </span>
                        <div :class="status.class" v-if="errors.has('identification_number')">
                            {{errors.get('identification_number')}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12">
                        <label class="hh-input-label">Business URL</label>
                        <span class="form-control overflow-x" :class="!userData.url ? 'form-color' : ''">
                            {{userData.url}}
                        </span>
                        <div :class="status.class" v-if="errors.has('url')">
                            {{errors.get('url')}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label class="hh-input-label">First Name</label>
                    <span class="form-control overflow-x" :class="!userData.first_name ? 'form-color' : ''">
                                {{userData.first_name}}
                            </span>
                    <div :class="status.class" v-if="errors.has('first_name')">
                      {{errors.get('first_name')}}
                    </div>
                  </div>

                  <div class="form-group col-sm-6">
                    <label class="hh-input-label">Last Name</label>
                    <span class="form-control overflow-x" :class="!userData.last_name ? 'form-color' : ''">
                                {{userData.last_name}}
                            </span>
                    <div :class="status.class" v-if="errors.has('last_name')">
                      {{errors.get('last_name')}}
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-12">
                        <label class="hh-input-label">SSN (last 4)</label>
                        <span class="form-control overflow-x"
                              :class="!userData.identification_number ? 'form-color' : ''">
                            {{userData.identification_number}}
                        </span>
                        <div :class="status.class" v-if="errors.has('identification_number')">
                            {{errors.get('identification_number')}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12">
                        <label class="hh-input-label">Profile URL</label>
                        <span class="form-control overflow-x" :class="!userData.url ? 'form-color' : ''">
                            {{userData.url}}
                        </span>
                        <div :class="status.class" v-if="errors.has('url')" class="margin-top-50">
                            {{errors.get('url')}}
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label class="hh-input-label">Date of birth</label>
                    <span class="form-control overflow-x" :class="!userData.date_of_birth ? 'form-color' : ''">
                            {{userData.date_of_birth}}
                        </span>
                    <div :class="status.class" class="margin-top-30" v-if="errors.has('date_of_birth')">
                      {{errors.get('date_of_birth')}}
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">Account number</label>
                    <span class="form-control overflow-x" :class="!userData.account_number ? 'form-color' : ''">
                        {{userData.account_number}}
                    </span>
                    <div :class="status.class" v-if="errors.has('account_number')">
                        {{errors.get('account_number')}}
                    </div>
                </div>
                <div class="form-group col-sm-6">
                    <label class="hh-input-label">Routing number</label>
                    <span class="form-control overflow-x" :class="!userData.routing_number ? 'form-color' : ''">
                        {{userData.routing_number}}
                    </span>
                    <div :class="status.class" v-if="errors.has('routing_number')">
                        {{errors.get('routing_number')}}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="editMode" class="margin-top-40 margin-bottom-20">
                 <div class="row margin-bottom-20">
                  <div class="form-group col-sm-12">
                    <div class="hh-checkbox">
                      <input
                        id="is_for_business"
                        type="checkbox"
                        v-model="formData.is_for_business"
                      />
                      <label
                        for="is_for_business"
                        class="margin-left-10 is-for-business"
                      >
                        Is this account made on behalf of an organization?
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="formData.is_for_business">
                  <div class="form-group col-sm-12">
                    <input-label
                      type="text"
                      css-class="form-control"
                      v-model="formData.business_name"
                      placeholder="Legal Business Name"
                      autocomplete="nope"
                      :required="true"
                    />
                      <div
                        class="invalid-feedback-red"
                        v-if="errors.has('business_name')"
                      >
                        {{ errors.get("business_name") }}
                      </div>
                  </div>
                   <div class="form-group col-sm-12">
                      <label class="hh-input-label">Business Type</label>
                        <div class="hh-input-label-wrapper">
                            <div class="hh-select" :class="formData.business_type ? 'hh-input-label-active' : ''">
                                <v-select :options="availableBusinessTypes"
                                          v-model="formData.business_type" placeholder="Business type"
                                          :reduce="item => item.code"/>
                            </div>                          
                        </div>
                        <div class="invalid-feedback-red" v-if="errors.has('business_type')">
                            {{errors.get('business_type')}}
                        </div>
                    </div>
                </div>
                <div v-else>
                <div class="row">
                  <div class="form-group col-sm-12">
                    <form-date
                      v-model="formData.date_of_birth"
                      :edit-mode="true"
                      :with-label="true"
                    />
                    <div class="invalid-feedback-red" v-if="errors.has('date_of_birth')"
                    >
                      {{ errors.get("date_of_birth") }}
                    </div>
                    <div class="invalid-feedback-red" v-if="customErrors.date">
                      {{ customErrors.date }}
                    </div>
                  </div>
                </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-6">
                    <input-label
                      type="text"
                      css-class="form-control"
                      id="first_name"
                      v-model="formData.first_name"
                      :placeholder="formData.is_for_business ? 'Business Representative First Name' : 'First Name'"
                      autocomplete="nope"
                      :required="true"
                    />
                      <div
                        class="invalid-feedback-red"
                        v-if="errors.has('first_name')"
                      >
                        {{ errors.get("first_name") }}
                      </div>
                  </div>

                  <div class="form-group col-sm-6">
                    <input-label
                      type="text"
                      css-class="form-control"
                      id="last_name"
                      v-model="formData.last_name"
                       :placeholder="formData.is_for_business ? 'Business Representative Last Name' : 'Last Name'"
                      autocomplete="nope"
                      required
                    />
                      <div
                        class="invalid-feedback-red"
                        v-if="errors.has('last_name')"
                      >
                        {{ errors.get("last_name") }}
                      </div>
                  </div>
                </div>

            <div v-if="formData.is_for_business">
                <div class="row">
                    <div class="form-group col-sm-12">
                        <input-label type="text" css-class="form-control" v-model="formData.identification_number"
                                     :label="`${formData.business_name ? formData.business_name : 'Business'} Tax ID`" autocomplete="off" required
                                     placeholder="Format: 00-0000000"/>
                        <div class="invalid-feedback-red" v-if="errors.has('identification_number')">
                            {{errors.get('identification_number')}}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="form-group col-sm-12">
                        <input-label type="text" css-class="form-control" v-model="formData.identification_number"
                                     label="SSN (last 4)" autocomplete="off" required
                                     placeholder="Format: 0000"/>
                        <div class="invalid-feedback-red" v-if="errors.has('identification_number')">
                            {{errors.get('identification_number')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
              <div class="form-group col-sm-12">
                <input-label type="text" css-class="form-control" v-model="formData.url"
                             @blur="validateUrl"
                             label="Website URL" autocomplete="off" required
                             placeholder="Format: https://www.helpahero.com. No website? Enter the facebook URL for your cause."/>
                <div class="invalid-feedback-red" v-if="errors.has('url')">
                  {{errors.get('url')}}
                </div>
                <div class="invalid-feedback-red" v-if="customErrors.url">
                  {{customErrors.url}}
                </div>
              </div>
            </div>

            <div class="row" v-if="showNonEditable">
                <div class="form-group col-sm-6">
                    <input-label css-class="form-control" v-model="formData.account_number"
                                 type="text"
                                 label="Account number"
                                 required
                                  placeholder="Format: 000123456789"/>
                    <div class="invalid-feedback-red" v-if="errors.has('account_number')">
                        {{errors.get('account_number')}}
                    </div>
                </div>

                <div class="form-group col-sm-6">
                    <input-label css-class="form-control" v-model="formData.routing_number"
                                 type="text"
                                 label="Routing number"
                                 required
                                 placeholder="Format: 110000000"/>
                    <div class="invalid-feedback-red" v-if="errors.has('routing_number')">
                        {{errors.get('routing_number')}}
                    </div>
                </div>
            </div>

          <div class="row account-agreement">
            <div class="form-group col-sm-12">
              <div class="hh-checkbox">
                <input
                    id="accept_terms"
                    type="checkbox"
                    required
                    v-model="formData.accept_terms"
                />
                <label
                    for="accept_terms"
                    class="margin-left-10 is-for-business"
                >
                  Accept <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener">Stripe Connected Account Agreement</a>
                </label>
                <div class="invalid-feedback-red" v-if="errors.has('accept_terms')">
                  {{errors.get('accept_terms')}}
                </div>
              </div>
            </div>
          </div>

        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vSelect from 'vue-select'
  import InputLabel from './elements/InputLabel'
  import FormDate from "./elements/FormDate";
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'PayoutInformation',

    components: {
      vSelect,
      InputLabel,
      FormDate,
      'font-awesome-icon': FontAwesomeIcon
    },

    props: {
      userData: {
        business_type: String,
        business_name: String,
        url: String,
        identification_number: String,
        account_number: String,
        routing_number: String,
        status_label: String,
        state: Object,
        is_for_business: Boolean,
        accept_terms: Boolean,
      },
      showEdit: Boolean,
      editMode: Boolean,
      showNonEditable: Boolean,
      showTitle: Boolean,
      editInformationRouteName: String,
      errors: Object,
      staticData: Object,
      userRoles: Array,
    },

    data: () => {
      return {
        loading: true,
        customErrors: {
          url: null
        },
        formData: {
          business_type: null,
          business_name: null,
          url: null,
          identification_number: null,
          account_number: null,
          routing_number: null,
          is_for_business: false,
          accept_terms: false,
          opType: 'update',
        },
      }
    },

    beforeMount () {
      this.formData = { ...this.formData, ...this.userData }
      this.formData.is_for_business = !_.isEmpty(this.formData.business_name)
      if (!this.editMode && this.userData.state) {
        this.errors.record(this.userData.state.errors)
      }
    },

    mounted () {
      this.$emit('componentLoading', this.$options.name, false)
    },

    methods: {
      validateUrl () {
        const urlPattern = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
        if (!urlPattern.test(this.formData.url)) {
          this.customErrors.url = 'Please add a valid URL'
        } else {
          this.customErrors.url = null
        }
      },

      toggleEditMode () {
        if (this.editInformationRouteName) {
          this.$router.push({ name: this.editInformationRouteName })
          return true
        }
        this.$emit('toggleEditMode')
      },

      canSubmit () {
        return !this.hasErrors
      },
    },

    computed: {
      hasErrors () {
        for (let error in this.customErrors) {
          if (this.customErrors[error]) {
            return true
          }
        }
        return false
      },

      availableBusinessTypes () {
        let result = []

        for (const [key, value] of Object.entries(this.staticData.available_business_types)) {
          result.push({ label: value, code: key })
        }

        return result
      },

      businessTypeLabel () {
        for (const [key, value] of Object.entries(this.staticData.available_business_types)) {
          if (key === this.userData.business_type) {
            return value
          }
        }

        return null
      },

      status () {
        let result = {
          'icon': null,
          'class': null
        }

        switch (this.userData.status_label) {
          case 'Ok':
            result.icon = 'check'
            result.class = 'text-success'
            break
          case 'Warning':
            result.icon = 'exclamation-triangle'
            result.class = 'text-warning'
            break
          case 'Alert':
            result.icon = 'exclamation-triangle'
            result.class = 'text-alert'
            break
          case 'Critical':
            result.icon = 'exclamation-triangle'
            result.class = 'text-danger'
            break
          case 'Unknown':
            result.icon = 'question'
            result.class = 'text-gray'
            break
          case 'Review':
            result.icon = 'clipboard-list'
            result.class = 'text-gray'
            break
        }

        return result
      }
    },

    watch: {
      hasErrors (to, from) {
        this.$emit('setPayoutFormState', !to)
      },
    }
  }
</script>

<style scoped>
  .status-icon {
    margin-bottom: 5px; 
    margin-right: 5px; 
    margin-left: -10px;
  }

  .form-control.overflow-x {
    height: 55px;
    padding: 12px;
    display: flex;
    align-items: center;
  }

  .margin-top-50 {
    margin-top: 50px;
  }

  h3 {
    font-family: Circular Std;font-style: normal;font-weight: bold;font-size: 26px !important; line-height: 33px !important;letter-spacing: -0.01em;  color: #000000;
  }


  h6 {
    padding-left: 0px;font-family: Circular Std; font-style: normal; font-weight: 500; font-size: 14px; line-height: 15px;color: #1DC071;
  }

  .ml-auto {
    margin-left: auto;
  }

  .pr-0 {
    padding-right: 0px;
  }

  .mt-5 {
    margin-top: 5px;
  }

  .edit-info-text {
      font-family: Circular Std;
      font-style: normal;
      font-weight: 450;
      font-size: 15px;
      line-height: 15px;
      color: #1781EF;
  }

  .d-flex {
    justify-content: start;
  }

</style>